import React, { CSSProperties, FC } from 'react'
import SwipeableViews from 'react-swipeable-views'

import { Button } from 'src/chrome'
import {
  getComputedFullBleeds,
  getComputedSingleFullBleeds,
  getSinglePanelIndex,
  getSinglePanelIndexMap,
} from '../../../redux/selectors/editor'
import FullBleedComponent from '../FullBleed'
import styles from '../../styles/editor.module.scss'
import { Api } from '../../api'

const tabStyles = {
  swipeableView: {
    position: 'relative',
    height: '100%',
  } as CSSProperties,
  slide: {
    position: 'relative',
    height: '100%',
    overflow: 'initial',
  } as CSSProperties,
  containerStyle: {
    height: '100%',
    width: '100vw',
    alignItems: 'center',
  } as CSSProperties,
}

type Props = {
  swipeableViewWidth: string
  api: Api
  saveButtonLabel: string
}

const EditorTabs: FC<Props> = props => {
  const { swipeableViewWidth, api, saveButtonLabel } = props
  const {
    handleSaveAndSend,
    card,
    panelView,
    setPanelView,
    step,
    fullBleeds,
    isMobile,
    setStep,
  } = api
  const { fullBleedIndex, panelIndex } = step
  const computedFullBleeds =
    panelView === 'fullbleed'
      ? getComputedFullBleeds(card, fullBleeds, step)
      : getComputedSingleFullBleeds(card, fullBleeds, step)

  const mobilePanelLocation = getSinglePanelIndex(
    fullBleeds,
    fullBleedIndex,
    panelIndex,
  )

  const handleIndexChange = (index: number) => {
    if (panelView === 'fullbleed') {
      setStep({ ...step, fullBleedIndex: index })
    } else {
      const { fullBleedIndex, panelIndex } = getSinglePanelIndexMap(fullBleeds)[
        index
      ]
      setStep({ ...step, fullBleedIndex, panelIndex })
    }
  }

  return (
    <section
      id={'editor-window'}
      className={styles.tabContent}
      style={
        {
          display: 'flex',
          justifyContent: 'center',
          verticalAlign: 'middle',
          alignItems: 'center',
          alignContent: 'center',
          overflowY: 'hidden',
        } as CSSProperties
      }
    >
      <SwipeableViews
        index={panelView === 'fullbleed' ? fullBleedIndex : mobilePanelLocation}
        onChangeIndex={handleIndexChange}
        style={tabStyles.swipeableView}
        containerStyle={
          {
            ...tabStyles.containerStyle,
            width: swipeableViewWidth,
          } as CSSProperties
        }
        slideStyle={
          {
            ...tabStyles.slide,
            ...(isMobile && { height: 'initial' }),
          } as CSSProperties
        }
      >
        {computedFullBleeds.map(
          (fullBleed, index): JSX.Element => {
            return (
              <div
                key={index}
                style={
                  {
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  } as CSSProperties
                }
              >
                <div
                  style={
                    { position: 'relative', width: '100%' } as CSSProperties
                  }
                >
                  <FullBleedComponent api={api} fullBleed={fullBleed} />
                </div>
              </div>
            )
          },
        )}
      </SwipeableViews>
      {/*
           NOTES:
           We do not allow design overrides for catalog cards in the Prompt Editor. If element.locked do not try to replace elements!
           Users May select a custom template layout on any panel that is not supplied a design or element.locked is false.
           All editor actions are preformed within a <Drawer /> component <Images/ImageFilters/Text/Templates>.
           Variations are supplied by the { SendableCard } object and only if a Variations [array] exists.
           A Variation is Supplied by the card designer and provides the ability to change the card designs; color/font/assets.
        */}
      <div className={styles.callToAction}>
        {isMobile && (
          <Button
            title={panelView === 'fullbleed' ? 'Panel View' : 'Spanned View'}
            onClick={() =>
              setPanelView(panelView === 'panel' ? 'fullbleed' : 'panel')
            }
          />
        )}
        {isMobile && (
          <Button
            id={`save_and_send_btn`}
            title={saveButtonLabel}
            onClick={() => handleSaveAndSend()}
          />
        )}
      </div>
    </section>
  )
}

export default EditorTabs
